import { Link } from "react-router-dom";

export default function FooterSection() {
  return (
    <div className="bg-[#111111]/60 backdrop-blur-sm rounded-2xl border border-white/[0.08] p-8 mt-8">
      <div className="text-center">
        <div className="text-white/60 space-y-1 mb-6">
          <p className="font-semibold text-white">Nova Vertex LTD</p>
          <p>66 Lavender Hill</p>
          <p>London</p>
          <p>SW11 5RQ</p>
          <p>United Kingdom</p>
        </div>
        <div className="space-y-3">
          <p className="text-white/70">
            <a
              href="mailto:support@novavertextech.com"
              className="text-white/70 hover:text-white font-medium transition-colors"
            >
              support@novavertextech.com
            </a>
          </p>
          <p className="text-white/70 font-medium">+44 7520 663474</p>
        </div>
      </div>
    </div>
  );
}